import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";

import {LeadButtonTerms} from "../../../application/components/LeadButtonTerms";
import {LeadRodoTerms} from "../../../application/components/LeadRodoTerms";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {AmplitudeAuthPlacement} from "../../../tracking/types/AmplitudeAuthPlacement";
import {AuthActionType} from "../../types/AuthActionType";
import {LoginForm} from "./LoginForm";
import {SocialAuth} from "./SocialAuth";
import {UserDataAdministrator} from "./UserDataAdministrator";

interface IProps {
    onAuthSuccess: (authActionType: AuthActionType) => void;
    onSwitchToRegister: () => void;
    userSource: UserSource;
    gtmSourceSection?: string;
    wrapperClassName?: string;
    amplitudePlacement?: AmplitudeAuthPlacement | null;
}

const loginButtonText = "Zaloguj się";

export const LoginCard = (props: IProps) => {
    const handleLoginSuccess = () => {
        props.onAuthSuccess(AuthActionType.LOGIN);
    };

    return (
        <div className={cx(card, props.wrapperClassName)}>
            <Text align="center" variant="headline_6" className={css({marginBottom: 3})}>
                Zaloguj się
            </Text>

            <LoginForm
                onSuccessfulSubmit={handleLoginSuccess}
                userSource={props.userSource}
                gtmSourceSection={props.gtmSourceSection}
                amplitudePlacement={props.amplitudePlacement}
            />

            <Text align="center" as="div" variant="info_txt_2" className={dividerTextStyle}>
                Lub
            </Text>

            <SocialAuth
                onAuthSuccess={props.onAuthSuccess}
                userSource={props.userSource}
                gtmSourceSection={props.gtmSourceSection}
                amplitudePlacement={props.amplitudePlacement}
                authContext="login"
            />

            <div className={signUp}>
                <Text variant="info_txt_1">Nie masz jeszcze konta?</Text>

                <Button onClick={props.onSwitchToRegister} variant="highlight_primary">
                    Zarejestruj się
                </Button>
            </div>
            <div className={leadTerms}>
                <LeadButtonTerms buttonText={loginButtonText} />
                <LeadRodoTerms />
            </div>
            <UserDataAdministrator />
        </div>
    );
};

const card = css({
    width: "100%",
    backgroundColor: "#fff",
    paddingY: 3,
    paddingX: 2
});

const signUp = css({
    borderTop: "1px solid var(--colors-gray-200)",
    paddingTop: 3,
    marginBottom: 3,
    marginTop: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    rowGap: 1.5
});

const leadTerms = css({
    display: "flex",
    flexDirection: "column",
    gap: 2,
    pb: 2,
    textAlign: "center"
});

const dividerTextStyle = css({
    marginTop: 3,
    marginBottom: 1.5
});
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";

import {LeadButtonTerms} from "../../../application/components/LeadButtonTerms";
import {LeadRodoTerms} from "../../../application/components/LeadRodoTerms";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {AmplitudeAuthPlacement} from "../../../tracking/types/AmplitudeAuthPlacement";
import {AuthActionType} from "../../types/AuthActionType";
import {LoginForm} from "./LoginForm";
import {SocialAuth} from "./SocialAuth";
import {UserDataAdministrator} from "./UserDataAdministrator";

interface IProps {
    onAuthSuccess: (authActionType: AuthActionType) => void;
    onSwitchToRegister: () => void;
    userSource: UserSource;
    gtmSourceSection?: string;
    wrapperClassName?: string;
    amplitudePlacement?: AmplitudeAuthPlacement | null;
}

const loginButtonText = "Zaloguj się";

export const LoginCard = (props: IProps) => {
    const handleLoginSuccess = () => {
        props.onAuthSuccess(AuthActionType.LOGIN);
    };

    return (
        <div className={cx(card, props.wrapperClassName)}>
            <Text align="center" variant="headline_6" className={css({marginBottom: 3})}>
                Zaloguj się
            </Text>

            <LoginForm
                onSuccessfulSubmit={handleLoginSuccess}
                userSource={props.userSource}
                gtmSourceSection={props.gtmSourceSection}
                amplitudePlacement={props.amplitudePlacement}
            />

            <Text align="center" as="div" variant="info_txt_2" className={dividerTextStyle}>
                Lub
            </Text>

            <SocialAuth
                onAuthSuccess={props.onAuthSuccess}
                userSource={props.userSource}
                gtmSourceSection={props.gtmSourceSection}
                amplitudePlacement={props.amplitudePlacement}
                authContext="login"
            />

            <div className={signUp}>
                <Text variant="info_txt_1">Nie masz jeszcze konta?</Text>

                <Button onClick={props.onSwitchToRegister} variant="highlight_primary">
                    Zarejestruj się
                </Button>
            </div>
            <div className={leadTerms}>
                <LeadButtonTerms buttonText={loginButtonText} />
                <LeadRodoTerms />
            </div>
            <UserDataAdministrator />
        </div>
    );
};

const card = css({
    width: "100%",
    backgroundColor: "#fff",
    paddingY: 3,
    paddingX: 2
});

const signUp = css({
    borderTop: "1px solid var(--colors-gray-200)",
    paddingTop: 3,
    marginBottom: 3,
    marginTop: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    rowGap: 1.5
});

const leadTerms = css({
    display: "flex",
    flexDirection: "column",
    gap: 2,
    pb: 2,
    textAlign: "center"
});

const dividerTextStyle = css({
    marginTop: 3,
    marginBottom: 1.5
});
